import React, { useRef } from "react";
import { useState, useEffect } from "react";
import AppContext from "../Context/Context";
import * as XLSX from "xlsx";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import { useGlobalState } from "../Context/GlobalStateContext";
import ConfirmationModal from "../App/ConfirmationModal";
type MyNotificationsProps = {
  ObjectType: any;
  ObjectIds: any;
};
function MyNotifications(props: MyNotificationsProps) {
  const globalState = useGlobalState();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  let isRead = params.get("ur") as any;

  const [showAnimation, setShowAnimation] = useState(false);
  const [showReadIcon, setShowReadIcon] = useState(true);
  const [notificationsTypeList, setNotificationsTypeList] = useState<any>([]);
  const [notificationsListsData, setNotificationsListsData] = useState<any>([]);

  const [notificationsFilters, setNotificationsFilters] = useState({
    All: true,
    Unread: false,
    Flagged: false,
    Target: false,
    NotificationsIDs: "",
    NumberOfRecords: 200,
    ActionRequired: false,
  });

  const [lastLoadedId, setLastLoadedId] = useState(0);
  const lastLoadedIdRef = useRef<any | null>(null);
  lastLoadedIdRef.current = lastLoadedId;

  useEffect(() => {
    if (isRead && isRead != "") {
      notificationsFilters.Unread = true;
    }
    getNotificationsTypeListsData();
  }, []);

  useEffect(() => {
    getNotificationsData(false);
  }, [notificationsFilters]);

  function getNotificationsTypeListsData() {
    let object = {} as any;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuote/GetNotificationsListsData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          globalState.setUpdateNotificationCount(
            !globalState.UpdateNotificationCount
          );

          //setNotificationsListsData(l_response[0]);
          let thisList = [];
          if (l_response && l_response[0]) {
            thisList = l_response[0];
          }

          if (
            notificationsTypeList &&
            notificationsTypeList.length > 0 &&
            notificationsTypeList.length == thisList.length
          ) {
            for (let index = 0; index < thisList.length; index++) {
              thisList[index].Selected = notificationsTypeList[index].Selected;
            }
          }

          setNotificationsTypeList(thisList);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getNotificationsData(scrollHit: boolean) {
    let object = {} as any;
    object.objecttype = props.ObjectType;
    object.objectids = props.ObjectIds;
    object.linkedobjecttype = 1;
    object.linkedobjectids = "";
    object.unread = notificationsFilters.Unread;
    object.flagged = notificationsFilters.Flagged;
    object.ntids = notificationsFilters.NotificationsIDs;
    object.stdt = "";
    object.eddt = "";
    object.lastloadedid = lastLoadedIdRef.current;
    object.numberofrecords = notificationsFilters.NumberOfRecords;
    if (notificationsFilters.ActionRequired) {
      object.sortby = "ActionRequiredDate";
    } else {
      object.sortby = "";
    }

    setShowAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuote/GetNotificationsData", object)
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].length > 0) {
            lastLoadedIdRef.current =
              l_response[0][l_response[0].length - 1].PTNotificationID;

            setLastLoadedId(
              l_response[0][l_response[0].length - 1].PTNotificationID
            );
          }
          let showReadIcon = false;

          for (let i = 0; i < l_response[0].length; i++) {
            if (l_response[0][i].IsRead === false) {
              showReadIcon = true;
              break;
            }
          }

          setShowReadIcon(showReadIcon);
          if (scrollHit == false) {
            setNotificationsListsData(l_response[0]);
          } else {
            setNotificationsListsData([
              ...notificationsListsData,
              ...l_response[0],
            ]);
          }
          //console.log(l_response[0]);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function setNotificationsStatusDataLocally(
    pid: any,
    actiontype: any,
    index: any
  ) {
    lastLoadedIdRef.current = 0;
    setLastLoadedId(0);
    let thisNotificationsListsData = [...notificationsListsData];

    if (actiontype == 1) {
      thisNotificationsListsData[index].IsRead =
        !thisNotificationsListsData[index].IsRead;
    } else if (actiontype == 2) {
      thisNotificationsListsData[index].IsFlag =
        !thisNotificationsListsData[index].IsFlag;
    }

    //setNotificationsListsData(thisNotificationsListsData);
    setNotificationsStatusData(pid, actiontype);
  }

  function setNotificationsStatusData(pid: any, actiontype: any) {
    let object = {} as any;
    object.pid = pid;
    object.actiontype = actiontype;
    object.ntids = notificationsFilters.NotificationsIDs;
    lastLoadedIdRef.current = 0;
    setLastLoadedId(0);
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuote/SetNotificationsStatusData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          getNotificationsTypeListsData();
          getNotificationsData(false);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function selectunSelectAll() {
    lastLoadedIdRef.current = 0;
    setLastLoadedId(0);

    if (notificationsFilters.All) {
      notificationsFilters.NotificationsIDs = "-1";
    } else {
      notificationsFilters.NotificationsIDs = "";
    }

    setNotificationsFilters((prevState: any) => ({
      ...prevState,
      All: !notificationsFilters.All,
    }));

    let thisNotificationsTypeList = [...notificationsTypeList];
    for (let i = 0; i < thisNotificationsTypeList.length; i++) {
      if (notificationsFilters.NotificationsIDs == "") {
        thisNotificationsTypeList[i].Selected = true;
      } else {
        thisNotificationsTypeList[i].Selected = false;
      }
    }

    setNotificationsTypeList(thisNotificationsTypeList);
  }

  function getUnreadNotification() {
    lastLoadedIdRef.current = 0;
    setLastLoadedId(0);
    setNotificationsFilters((prevState: any) => ({
      ...prevState,
      Unread: !notificationsFilters.Unread,
    }));
  }

  function getTargetNotification() {
    lastLoadedIdRef.current = 0;
    setLastLoadedId(0);
    setNotificationsFilters((prevState: any) => ({
      ...prevState,
      Target: !notificationsFilters.Target,
    }));
  }

  function getFlaggedNotification() {
    lastLoadedIdRef.current = 0;
    setLastLoadedId(0);
    setNotificationsFilters((prevState: any) => ({
      ...prevState,
      Flagged: !notificationsFilters.Flagged,
    }));
  }

  function getActionRequiredNotification() {
    lastLoadedIdRef.current = 0;
    setLastLoadedId(0);
    setNotificationsFilters((prevState: any) => ({
      ...prevState,
      ActionRequired: !notificationsFilters.ActionRequired,
    }));
  }

  function getSelectedNotificationType(index: any) {
    lastLoadedIdRef.current = 0;
    setLastLoadedId(0);

    let thisNotificationsTypeList = [...notificationsTypeList];
    thisNotificationsTypeList[index].Selected =
      !thisNotificationsTypeList[index].Selected;

    let selectedIds = "";
    let allSelected = true;

    for (let i = 0; i < thisNotificationsTypeList.length; i++) {
      if (thisNotificationsTypeList[i].Selected) {
        selectedIds += thisNotificationsTypeList[i].PTNotificationTypeID + ",";
      } else {
        allSelected = false;
      }
    }

    if (selectedIds != "") {
      selectedIds = selectedIds.replace(/,$/, "");
    }

    if (selectedIds == "") {
      selectedIds = "-1";
    }

    setNotificationsTypeList(thisNotificationsTypeList);

    if (allSelected) {
      setNotificationsFilters((prevState: any) => ({
        ...prevState,
        All: true,
      }));
    } else {
      setNotificationsFilters((prevState: any) => ({
        ...prevState,
        All: false,
      }));
    }

    setNotificationsFilters((prevState: any) => ({
      ...prevState,
      NotificationsIDs: selectedIds,
    }));
  }

  const handleScroll = (e: any) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollTop + clientHeight >= scrollHeight) {
      // bottom hit
      getNotificationsData(true);
    }

    if (scrollTop === 0) {
      // top hit
    }
  };
  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 100) {
      if (obj.isConfirm === true) {
        setNotificationsStatusData(0, obj.SelectedID);
      }
    }
    if (obj.ID === 101) {
      if (obj.isConfirm === true) {
        setNotificationsStatusData(0, obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }
  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />
      <div className="inline-block-d width-100 p-all10">
        <div className="flex-container flex-da flex-jsb">
          <div className="flex-da flex-gap10 mb-10 btns-notify">
            <a
              className={` ${
                notificationsFilters.All ? "n-all-selected" : "unSelected"
              }`}
              onClick={() => selectunSelectAll()}
            >
              All
            </a>
            <a
              className={` ${
                notificationsFilters.Unread ? "n-unread-selected" : "unSelected"
              }`}
              onClick={() => getUnreadNotification()}
            >
              Unread
            </a>
            <a
              className={` ${
                notificationsFilters.Flagged ? "n-flag-selected" : "unSelected"
              }`}
              onClick={() => getFlaggedNotification()}
            >
              Flagged
            </a>

            {notificationsTypeList &&
              notificationsTypeList.map((item: any, index: any) => (
                <React.Fragment key={index}>
                  <a
                    onClick={() => getSelectedNotificationType(index)}
                    className={` ${
                      item.Selected ? "n-flag-selected2" : "unSelected"
                    }`}
                  >
                    {item.Title}
                    {item.UnReadCount > 0 && (
                      <span className="notify-count">{item.UnReadCount}</span>
                    )}
                  </a>
                </React.Fragment>
              ))}
          </div>
          <div className="flex-da flex-gap10">
            {showReadIcon && (
              <a
                title="Mark All As Read"
                onClick={() =>
                  globalState.setConfirmationModalObject({
                    ShowPopup: true,
                    Heading: "Alert",
                    Message: "Are your sure, you want to mark all as read?",
                    ID: 101,
                    SelectedID: 4,
                    OtherID: 0,
                  })
                }
              >
                <img src="images/unread.svg" width={30} height={30} />
              </a>
            )}

            {notificationsListsData && notificationsListsData.length > 0 && (
              <a
                title="Delete All"
                onClick={() =>
                  globalState.setConfirmationModalObject({
                    ShowPopup: true,
                    Heading: "Alert",
                    Message: "Are your sure, you want to delete all records?",
                    ID: 100,
                    SelectedID: 6,
                    OtherID: 0,
                  })
                }
              >
                <img src="images/delete.png" width={30} height={30} />
              </a>
            )}
          </div>
          {/* <div className="btns-notify">
            <a
              title="Sort by Actions Required Date"
              className={` ${
                notificationsFilters.ActionRequired
                  ? "n-flag-selected a-req-btn"
                  : "unSelected a-req-btn"
              }`}
              onClick={() => getActionRequiredNotification()}
            >
              <img
                src={
                  notificationsFilters.ActionRequired == false
                    ? "images/a-req-g.svg"
                    : "images/a-req.svg"
                }
                width={28}
                height={28}
              />
            </a>
          </div> */}
        </div>

        <div className="notify-main" onScroll={handleScroll}>
          {notificationsListsData &&
            notificationsListsData.map((item: any, index: any) => (
              <div
                key={index}
                className={
                  item.IsRead == true ? "notify-row" : "notify-row notify-Bold"
                }
              >
                <div className="flex-da flex-gap10 n-flex-left">
                  <span className={"notify-type" + " " + item.PTClass}>
                    {item.NotificationType}
                  </span>
                  {/* <a className="title-quarter" href={item.SourceLink}>
                    {item.Title1}
                  </a> */}
                  <a className="title-quarter" href={item.SourceLink}>
                    {item.Title2}
                  </a>
                  <a
                    className="title-retailer"
                    title={item.Title3}
                    href={item.SourceLink}
                  >
                    {item.Title3}
                  </a>
                </div>

                <a
                  className="title-notify"
                  title={item.DisplayText}
                  href={item.SourceLink}
                >
                  {item.DisplayText}
                </a>
                <div className="flex-da flex-gap10 n-flex-right">
                  <a
                    title={`${
                      !item.IsFlag ? "Mark as Flag" : "Mark as UnFlag"
                    }`}
                    onClick={() =>
                      setNotificationsStatusDataLocally(
                        item.PTNotificationUserID,
                        2,
                        index
                      )
                    }
                  >
                    {item.IsFlag && (
                      <img src="images/flagged.svg" width={21} height={22} />
                    )}
                    {!item.IsFlag && (
                      <img src="images/nflagged.svg" width={21} height={22} />
                    )}
                    {/* {item.IsFlag == true ? "flagged" : "notflagged"} -{" "} */}
                  </a>
                  <a
                    title={`${
                      !item.IsRead ? "Mark as Read" : "Mark as UnRead"
                    }`}
                    onClick={() =>
                      setNotificationsStatusDataLocally(
                        item.PTNotificationUserID,
                        1,
                        index
                      )
                    }
                  >
                    {!item.IsRead && (
                      <img src="images/unread.svg" width={26} height={25} />
                    )}
                    {item.IsRead && (
                      <img src="images/read.svg" width={27} height={27} />
                    )}
                    {/* {item.IsRead == true ? "read" : "unread"} */}
                  </a>
                  <div className="notify-time">
                    <img src="images/clock.svg" width={18} height={18} />
                    {moment(item.TimeAdded).format(
                      "DD MMMM YYYY [at] hh:mm A z"
                    )}{" "}
                    {/* {momenttimezone()
                        .tz(momenttimezone.tz.guess())
                        .format("z")} */}
                    {/* {showDateFormateAccordingToZone_Formatted(item.TimeAdded,true)} */}
                  </div>
                  <a
                    onClick={() =>
                      setNotificationsStatusDataLocally(
                        item.PTNotificationUserID,
                        3,
                        index
                      )
                    }
                  >
                    <img src="images/delete.png" width={18} height={18} />
                    {/* {item.IsRead == true ? "read" : "unread"} */}
                  </a>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}

export default MyNotifications;
